module.exports = __webpack_public_path__ + "static/media/blue_cat.f842c271.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blue_cat.png
// module id = 854
// module chunks = 0